var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.333,
    height: 20.2,
    viewBox: "0 0 20.333 20.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1570",
    d: "M19.873.393a1 1 0 00-1.414 0l-8.292 8.293L1.874.393A1 1 0 00.46 1.807L8.753 10.1.46 18.393a1 1 0 101.414 1.414l8.293-8.293 8.293 8.293a1 1 0 001.414-1.414L11.581 10.1l8.293-8.293a1 1 0 00-.001-1.414z",
    fill: "#fff",
    stroke: "#181818",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewClose);
export default __webpack_public_path__ + "static/media/preview_close.c837e38ec31373f15cd8122ab5f788c5.svg";
export { ForwardRef as ReactComponent };